<div class="status-bar-colored-bottom"></div>
<div class="padding-safe-top full-size-safe-scrollable">

  @if (hymn) {
    <div id="presentation-app">
      <div id="presentation-content" #content
           doubletap (doubletap)="onDoubleTap()"
           swipeGesture [axis]="'x'" (swipeleft)="onSwipeNext()" (swiperight)="onSwipePrevious()"
           appPinchZoom
           [minZoom]="fontSizeMin"
           [maxZoom]="fontSizeMax"
           [currentZoom]="fontsize"
           (zoomChange)="previewLinesPerVerse($event)"
           (zoomEnd)="updateLinesPerVerse($event)">

        <div class="presentationText text-stroked" [style.font-family]="presentFontFamily || null" [style.font-weight]="presentFontWeight || null">
          <mat-card class="hymnTitle mat-card-main mat-card-centered">
            <mat-card-content [style.font-size]="textSizeStyle">
              <p id="hymnTitle" class="presentationText" #hymnTitle>{{translation.hymn}} {{hymn.hymnNumber}} - {{hymn.title}}</p>
            </mat-card-content>
          </mat-card>

          <mat-card id="presentationTextCard" class="mat-card-centered mat-card-main" [style.font-size]="textSizeStyle">
            <mat-card-header>
              <i id="verseNumber" class="presentationText" #verseNumber>
                {{(activeVerse != 'R'? translation.verse + ' ' + activeVerse : translation.refrain) + (visibleSectionIndex > 0 ? ' ('+translation.continued+')':'')}}
              </i>
            </mat-card-header>
            <mat-card-content>
              <div id="hymnText" class="presentationText" #hymnText>
                @if (visibleVerseSections && visibleVerseSections.get(visibleSectionIndex)) {
                  @for (line of visibleVerseSections.get(visibleSectionIndex)?.lines; track $index) {
                    <p class="verse-line" [style.font-size]="textSizeStyle" [innerHTML]="line | karaokeMarkup"></p>
                  }
                }
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <mat-toolbar color="primary" class="sticky-toolbar-bottom">
        @if (!sidenavService.hymnListOpen) {
          <div class="padding-safe-left"></div>
        }

        <button (click)="toggleListSidenav()" mat-icon-button>
          <mat-icon>menu</mat-icon>
        </button>

        <span class="toolbar-fill-remaining-space"></span>

        @if (!layoutService.isNarrow()) {
          <button
            [style.visibility]="(visibleSectionIndex > 0 || activeVerseIndex > 0)? 'visible' : 'hidden'"
            mat-mini-fab (click)="navigateLeft()" class="my-fab navigate">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
        }

        <div style="display: flex; overflow-x: auto; white-space: nowrap;">
          @for (verse of hymn.verses; track $index; let i = $index) {
            @if (hymn.hasChorus && i == 1) {
              <button mat-mini-fab (click)="onVerseButtonClick('R')" [class]="activeVerse==='R'? 'my-fab-active' : 'my-fab'">R</button>
            }

            <button mat-mini-fab (click)="onVerseButtonClick((i+1).toString())" [class]="activeVerse===((i+1).toString())? 'my-fab-active' : 'my-fab'">{{(i+1).toString()}}</button>
          }
        </div>

        @if (!layoutService.isNarrow()) {
          <button
            [style.visibility]="((visibleSectionIndex < visibleVerseSections.size - 1) || (activeVerseIndex < (verseList.length - 1)))? 'visible' : 'hidden'"
            mat-mini-fab (click)="navigateRight()" class="my-fab navigate">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        }

        <span class="toolbar-fill-remaining-space"></span>

        @if (!layoutService.isNarrow()) {
          @if (settingService.isFavoriteOrHymnToLearn(hymn.hymnNumber)) {
            <button (click)="settingService.removeHymnFromFavoritesAndToLearn(hymn);" mat-icon-button>
              @if (settingService.isFavorite(hymn.hymnNumber)) {
                <mat-icon>favorite</mat-icon>
              }
              @if (settingService.isHymnToLearn(hymn.hymnNumber)) {
                <mat-icon>bookmark</mat-icon>
              }
            </button>
          } @else {
            <button [matMenuTriggerFor]="favoriteMenu" mat-icon-button>
              <mat-icon>favorite_border</mat-icon>
            </button>
          }

          <mat-menu #favoriteMenu="matMenu">
            <button (click)="settingService.toggleFavorite(hymn);" mat-menu-item>
              <mat-icon>favorite_border</mat-icon>
              <span>{{translation.add_to_favorites}}</span>
            </button>
            <button (click)="settingService.toggleHymnToLearn(hymn);" mat-menu-item>
              <mat-icon>bookmark_border</mat-icon>
              <span>{{translation.add_to_hymns_to_learn}}</span>
            </button>
          </mat-menu>

          <button mat-icon-button (click)="hymnSelectionService.dialpad()">
            <mat-icon>dialpad</mat-icon>
          </button>

          <button mat-icon-button [matMenuTriggerFor]="shuffleMenu">
            <mat-icon>shuffle</mat-icon>
          </button>

          <mat-menu #shuffleMenu="matMenu">
            <button [disabled]="settingService.getFavorites().length < 2" mat-menu-item (click)="hymnSelectionService.goToRandomHymn(true)">
              <mat-icon>shuffle</mat-icon>
              <span>{{translation.random_favorite}}</span>
            </button>
            <button mat-menu-item (click)="hymnSelectionService.goToRandomHymn(false)">
              <mat-icon>shuffle</mat-icon>
              <span>{{translation.random_hymn}}</span>
            </button>
          </mat-menu>

          <button mat-icon-button [matMenuTriggerFor]="viewModeMenu">
            <mat-icon>menu_book</mat-icon>
          </button>

          <mat-menu #viewModeMenu="matMenu">
            <button (click)="settingService.setHymnViewMode()" [routerLink]="['/'+translation.path_hymn, hymn.hymnNumber]" mat-menu-item>
              <mat-icon>menu_book</mat-icon>
              <span>{{translation.read_mode}}</span>
            </button>
            <button (click)="settingService.setSheetMusicViewMode()" [routerLink]="['/'+translation.path_sheet_music, hymn.hymnNumber]" mat-menu-item>
              <mat-icon>piano</mat-icon>
              <span>{{translation.sheet_music_mode}}</span>
            </button>
            <button (click)="settingService.setSheetMusicViewMode()" [routerLink]="['/'+translation.path_chords, hymn.hymnNumber]" mat-menu-item>
              <mat-icon svgIcon="guitar"></mat-icon>
              <span>{{translation.chord_mode}}</span>
            </button>
          </mat-menu>
        }

        <button mat-icon-button [matMenuTriggerFor]="presentMenu">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #presentMenu="matMenu">

          <button (click)="changeFontSize()" mat-menu-item>
            <mat-icon>text_fields</mat-icon>
            <span>{{translation.change_font_size}}</span>
          </button>

          @if (layoutService.isNotBrowser()) {
            <button mat-menu-item (click)="shareService.shareHymn(this.hymn)">
              <mat-icon>share</mat-icon>
              <span>{{translation.share_hymn}} {{hymn.hymnNumber}}</span>
            </button>
          }

          @if (layoutService.fullscreenSupported()) {
            <button (click)="toggleFullscreen()" mat-menu-item>
              <mat-icon>{{layoutService.fullscreen? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
              <span>{{layoutService.fullscreen? translation.fullscreen_exit : translation.fullscreen}}</span>
            </button>
          }

          @if (!layoutService.isNarrow()) {
            <button mat-menu-item (click)="modalService.openDialog('shortcuts', {'hymnViewMode': 'presentation'})">
              <mat-icon>keyboard_command_key</mat-icon>
              <span>{{translation.shortcuts}}</span>
            </button>
          }

          <button (click)="toggleSettingSidenav()" mat-menu-item>
            <mat-icon>settings</mat-icon>
            <span>{{translation.settings}}</span>
          </button>

          <button mat-menu-item (click)="shareService.suggestCorrection(this.hymn)">
            <mat-icon>create</mat-icon>
            <span>{{translation.suggest_correction}}</span>
          </button>

          @if (!layoutService.isNarrow() && layoutService.isNotBrowser()) {
            <button mat-menu-item (click)="shareService.shareApp();">
              <mat-icon>share</mat-icon>
              <span>{{translation.share_app}}</span>
            </button>
          }

          @if (layoutService.isNarrow()) {
            <button (click)="settingService.toggleFavorite(hymn);" mat-menu-item>
              @if (!settingService.isFavorite(hymn.hymnNumber)) {
                <mat-icon>favorite_border</mat-icon>
                <span>{{translation.add_to_favorites}}</span>
              } @else {
                <mat-icon>favorite</mat-icon>
                <span>{{translation.remove_from_favourites}}</span>
              }
            </button>

            <button (click)="settingService.toggleHymnToLearn(hymn);" mat-menu-item>
              @if (!settingService.isHymnToLearn(hymn.hymnNumber)) {
                <mat-icon>bookmark_border</mat-icon>
                <span>{{translation.add_to_hymns_to_learn}}</span>
              } @else {
                <mat-icon>bookmark</mat-icon>
                <span>{{translation.remove_from_hymns_to_learn}}</span>
              }
            </button>

            <button mat-menu-item (click)="hymnSelectionService.dialpad()">
              <mat-icon>dialpad</mat-icon>
              <span>{{translation.go_to_hymn_number}}</span>
            </button>

            <button [disabled]="settingService.getFavorites().length < 2" mat-menu-item (click)="hymnSelectionService.goToRandomHymn(true)">
              <mat-icon>shuffle</mat-icon>
              <span>{{translation.random_favorite}}</span>
            </button>

            <button mat-menu-item (click)="hymnSelectionService.goToRandomHymn(false)">
              <mat-icon>shuffle</mat-icon>
              <span>{{translation.random_hymn}}</span>
            </button>

            <button mat-menu-item [matMenuTriggerFor]="viewModeMenu">
              <mat-icon>menu_book</mat-icon>
              <span>View Mode</span>
            </button>

            <mat-menu #viewModeMenu="matMenu">
              <button (click)="settingService.setHymnViewMode()" [routerLink]="['/'+translation.path_hymn, hymn.hymnNumber]" mat-menu-item>
                <mat-icon>menu_book</mat-icon>
                <span>{{translation.read_mode}}</span>
              </button>
              <button (click)="settingService.setSheetMusicViewMode()" [routerLink]="['/'+translation.path_sheet_music, hymn.hymnNumber]" mat-menu-item>
                <mat-icon>piano</mat-icon>
                <span>{{translation.sheet_music_mode}}</span>
              </button>
              <button (click)="settingService.setSheetMusicViewMode()" [routerLink]="['/'+translation.path_chords, hymn.hymnNumber]" mat-menu-item>
                <mat-icon svgIcon="guitar"></mat-icon>
                <span>{{translation.chord_mode}}</span>
              </button>
            </mat-menu>
          }

        </mat-menu>

        @if (!settingService.settingsOpened) {
          <div class="padding-safe-right"></div>
        }
      </mat-toolbar>

      <app-music-control [autoscrollVisible]="true" [presentationMarkersAvailable]="hasPresentationMarkers" class="music-control-menu"></app-music-control>
    </div>
  }
</div>
